module.exports = __webpack_public_path__ + "static/media/editIcon.878fd75a.svg";